export default __webpack_public_path__ + "static/media/8.0cda3f76.svg";